import { render, staticRenderFns } from "./OrderMainScreen.vue?vue&type=template&id=6e8a8f3e&"
import script from "./OrderMainScreen.vue?vue&type=script&lang=js&"
export * from "./OrderMainScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports